import type { FC, ReactNode } from 'react'
import type { Offer } from '@/types/content'

import { cn } from '@/lib/utils'
import { MediaPlaceholder } from '@/components/generals/media-placeholder'
import { cms, hasValue } from '@/lib/cms'

interface OfferImageProps {
    offer: Offer
    className?: string
    priority?: boolean
    compact?: boolean
}

// The image of an offer from the "angebote" collection, or a labelled placeholder until one is uploaded.
export const OfferImage: FC<OfferImageProps> = ({ offer, className, priority = false, compact = false }): ReactNode => {
    return (
        <div className={cn('relative overflow-hidden bg-ink-soft', className)}>
            {hasValue(offer.bild)
                ? (
                    <img
                        src={offer.bild}
                        alt={offer.bild_alt || offer.name}
                        loading={priority ? 'eager' : 'lazy'}
                        decoding='async'
                        fetchPriority={priority ? 'high' : undefined}
                        className='absolute inset-0 size-full object-cover transition-transform duration-[1200ms] ease-brand group-hover:scale-[1.03]'
                    />
                )
                : (
                    <MediaPlaceholder
                        slotKey='ANGEBOTSBILD'
                        label={offer.name}
                        labelCms={cms('angebote', offer.id, 'name')}
                        ratio='4:5'
                        hint='Bild im CMS unter Angebote hochladen'
                        compact={compact}
                    />
                )}
        </div>
    )
}
